import api from './api';

const internPost = (action, params = {}) =>
  api.post(`/intern-portal/${action}`, { action, ...params }).then((res) => res.data);

// Dashboard
export const getDashboardStats = () => internPost('get_dashboard_stats');

// Profile
export const getMyProfile = () => internPost('get_my_profile');
export const updateMyProfile = (data) => internPost('update_my_profile', data);
export const getPhotoUploadUrl = () => internPost('get_photo_upload_url');
export const setPhotoUrl = (photoUrl) => internPost('set_photo_url', { photo_url: photoUrl });

// Available jobs (open bookings the intern can accept)
export const listAvailableJobs = () => internPost('list_available_jobs');
export const acceptBooking = (bookingId) =>
  internPost('accept_booking', { booking_id: bookingId });
export const declineBooking = (bookingId, reason = '') =>
  internPost('decline_booking', { booking_id: bookingId, reason });

// My bookings (confirmed assessments assigned to this intern)
export const listMyBookings = (filter = 'all') =>
  internPost('list_my_bookings', { filter });
export const getMyBooking = (bookingId) =>
  internPost('get_my_booking', { booking_id: bookingId });
export const cancelMyBooking = (bookingId, reason = '') =>
  internPost('cancel_my_booking', { booking_id: bookingId, reason });
export const startAssessment = (bookingId) =>
  internPost('start_assessment', { booking_id: bookingId });
export const completeAssessment = (bookingId, notes = '') =>
  internPost('complete_assessment', { booking_id: bookingId, notes });

// Assessment questionnaire
export const getAssessmentTemplate = (templateId, version) =>
  internPost('get_assessment_template', { template_id: templateId, ...(version ? { version } : {}) });
export const saveAssessmentDraft = ({ bookingId, templateId, templateVersion, responses, categoryId }) =>
  internPost('save_assessment_draft', {
    booking_id: bookingId,
    template_id: templateId,
    template_version: templateVersion,
    responses,
    ...(categoryId ? { category_id: categoryId } : {}),
  });
export const getAssessmentUploadUrl = (bookingId, questionId) =>
  internPost('get_assessment_upload_url', { booking_id: bookingId, question_id: questionId });
// Resubmit an assessment after a mentor requested revisions.
export const resubmitAssessment = ({ bookingId, responses, templateId, templateVersion }) =>
  internPost('resubmit_assessment', {
    booking_id: bookingId,
    responses,
    template_id: templateId,
    template_version: templateVersion,
  });

// Availability calendar
export const getMyAvailability = () => internPost('get_my_availability');
export const updateMyAvailability = (availability) =>
  internPost('update_my_availability', { availability });

// B6: Blackout / time-off dates
export const getBlackoutDates = () => internPost('get_blackout_dates');
export const setBlackoutDates = (blackoutDates) =>
  internPost('set_blackout_dates', { blackout_dates: blackoutDates });
export const removeBlackoutDate = (id) =>
  internPost('remove_blackout_date', { id });

// Earnings
export const getMyEarnings = () => internPost('get_my_earnings');

// Referrals
export const getMyReferrals = () => internPost('get_my_referrals');

// Intro video (onboarding: pending_video -> pending_review)
export const getVideoStatus = () => internPost('get_video_status');
export const getVideoUploadUrl = (contentType) =>
  internPost('get_video_upload_url', { content_type: contentType });
export const setVideoUrl = (key) => internPost('set_video_url', { key });

// Assessment onboarding test
export const startAssessmentTest = () => internPost('start_assessment_test');
export const submitAssessmentTest = (testId, answers) =>
  internPost('submit_assessment_test', { test_id: testId, answers });
export const getTestStatus = () => internPost('get_test_status');

// Stripe Connect (intern payouts)
export const getStripeStatus = () => internPost('get_stripe_status');
export const createStripeOnboardingLink = (returnUrl, refreshUrl) =>
  internPost('create_stripe_onboarding_link', { return_url: returnUrl, refresh_url: refreshUrl });
export const refreshStripeStatus = () => internPost('refresh_stripe_status');
